import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { Form } from "@ant-design/compatible";
import { message, Modal, Switch, Table, Tooltip } from "antd";

import ContainerShowInfo from "./containerShowInfo";
import EditableTable from "./editableCell";
import { dispensaries as dispensaryServices } from "../../../services";
import {
    DISPENSARY_PERMISSION,
    getPagePermissions,
} from "../../../security/permissions";
import gas_pump from "./../../../assets/images/mini_gas_pump.svg";
import ContainerInactiveMessage from "./ContainerInactiveMessage";

const { confirm } = Modal;

const ContainerGauges = ({ container, onUpdateContainers, onGaugeChange, pagePermissions }) => {
    const [stateContainer, setStateContainer] = useState(container);
    const [gauges, setGauges] = useState(container.gauges);
    const [loading, setLoading] = useState(false);
    const [includeInPreviousInventories, setIncludeInPreviousInventories] =
        useState(false);

    useEffect(() => {
        setStateContainer(container);
        setGauges(container.gauges);
    }, [container]);

    const updateStatusGauges = useCallback(() => {
        onUpdateContainers();
    }, [onUpdateContainers]);

    const handleGaugeChange = useCallback(() => {
        onGaugeChange();
    }, [onGaugeChange]);

    const expandedRowRender = () => (
        <EditableTable
            onGaugeChange={handleGaugeChange}
            container={stateContainer}
            gauges={gauges}
            containerStatus={stateContainer.containerStatus}
            onSomeGaugeStatusChange={updateStatusGauges}
            onDeleteGauges={onUpdateContainers}
        />
    );

    const data = [
        {
            key: container.containerKey,
            containerCode: container.containerKey,
            capacity: Intl.NumberFormat("en", { notation: "standard" }).format(
                container.containerTotalCapacity
            ),
            measurementUnit: (container.product.measurementUnit || {}).measurementDescription,
            idContainer: container.idContainer,
            warehouseKey: container.warehouseKey,
        },
    ];

    const columns = (pagePermissions) => [
        {
            title: "Código de contenedor",
            dataIndex: "containerCode",
            key: "containerCode",
            render: (text) => (
                <Tooltip title="Código Identificador del contenedor">
                    <label>{text}</label>
                </Tooltip>
            ),
        },
        {
            title: "Clave SAT Almacén",
            dataIndex: "warehouseKey",
            key: "warehouseKey",
            render: (text) => (
                <Tooltip title="Clave SAT del almacén">
                    <label style={{ color: "green", fontWeight: "bold" }}>{text}</label>
                </Tooltip>
            ),
        },
        {
            title: "Capacidad",
            dataIndex: "capacity",
            key: "capacity",
            render: (text, record) =>
                container.containerType === "TANQUE" ? (
                    <Tooltip title="Capacidad del Tanque">
                        <label className="dispensary-id">
                            {record.capacity} {record.measurementUnit}
                        </label>
                    </Tooltip>
                ) : (
                    <span></span>
                ),
        },
        {
            title: "Información",
            dataIndex: "idContainer",
            key: "idContainer",
            render: (text) => (
                <ContainerShowInfo
                    containerId={text}
                    onDeleteContainers={onUpdateContainers}
                />
            ),
        },
        pagePermissions.edit
            ? {
                title: "Acción",
                key: "action",
                align: "right",
                render: (text, record) => (
                    <Tooltip
                        title={
                            stateContainer.containerStatus
                                ? "Desactivar Contenedor"
                                : "No disponible"
                        }
                    >
                        <Switch
                            checked={stateContainer.containerStatus}
                            disabled={!stateContainer.containerStatus}
                            onChange={(e) =>
                                showInactiveConfirm(record.idContainer, e)
                            }
                        />
                    </Tooltip>
                ),
            }
            : {},
    ];

    const handleContainerStatus = (containerId, checked) => {
        let params = {
            status: checked,
            includeInventoryControl: includeInPreviousInventories,
        };
        dispensaryServices
            .put(`container/${containerId}/changeStatus`, params)
            .then((response) => {
                const jsonResponse = JSON.parse(JSON.stringify(response));
                if (jsonResponse.hasOwnProperty("response")) {
                    message.error(jsonResponse.response.data);
                }
                onUpdateContainers();
            });
    };

    const showInactiveConfirm = (containerId, checked) => {
        confirm({
            title: `¿Está seguro que desea desactivar el contenedor ${stateContainer.containerKey}?`,
            content: (
                <ContainerInactiveMessage
                    onChangeIncludeInPreviousInventories={setIncludeInPreviousInventories}
                />
            ),
            okText: "Sí",
            okType: "danger",
            cancelText: "No",
            width: 750,
            centered: true,
            onOk: () =>
                new Promise((resolve) => {
                    setTimeout(() => resolve(handleContainerStatus(containerId, checked)), 2000);
                }).catch(() => console.log("error")),
            onCancel() {},
        });
    };

    return (
        <div>
            <Table
                className="dispensary-table"
                columns={columns(pagePermissions)}
                expandIcon={() => <img src={gas_pump} alt="Contenedor" />}
                expandedRowRender={expandedRowRender}
                defaultExpandAllRows
                dataSource={data}
                showHeader={false}
                size="small"
                pagination={false}
                loading={loading}
            />
        </div>
    );
};

const mapStateToProps = ({ userData, userData: { permissions } }) => ({
    userData,
    pagePermissions: getPagePermissions(DISPENSARY_PERMISSION, permissions),
});

export default connect(mapStateToProps)(Form.create()(ContainerGauges));
